import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _2a861a9f = () => interopDefault(import('../../../pages/archive/index.vue' /* webpackChunkName: "pages/archive/index" */))
const _6c6d9574 = () => interopDefault(import('../../../pages/blocked.vue' /* webpackChunkName: "pages/blocked" */))
const _26c32e38 = () => interopDefault(import('../../../pages/builder/index.vue' /* webpackChunkName: "pages/builder/index" */))
const _513db31e = () => interopDefault(import('../../../pages/chat/index.vue' /* webpackChunkName: "pages/chat/index" */))
const _7f3fda2e = () => interopDefault(import('../../../pages/contacts.vue' /* webpackChunkName: "pages/contacts" */))
const _61e306ac = () => interopDefault(import('../../../pages/contacts/index.vue' /* webpackChunkName: "pages/contacts/index" */))
const _1c916cf8 = () => interopDefault(import('../../../pages/contacts/companies/index.vue' /* webpackChunkName: "pages/contacts/companies/index" */))
const _42a3a068 = () => interopDefault(import('../../../pages/contacts/people/index.vue' /* webpackChunkName: "pages/contacts/people/index" */))
const _764a88c7 = () => interopDefault(import('../../../pages/contacts/companies/add.vue' /* webpackChunkName: "pages/contacts/companies/add" */))
const _959a4f92 = () => interopDefault(import('../../../pages/contacts/people/add.vue' /* webpackChunkName: "pages/contacts/people/add" */))
const _43d6c143 = () => interopDefault(import('../../../pages/contacts/companies/_companyId.vue' /* webpackChunkName: "pages/contacts/companies/_companyId" */))
const _510966c5 = () => interopDefault(import('../../../pages/contacts/people/_personId.vue' /* webpackChunkName: "pages/contacts/people/_personId" */))
const _ed7a6ed6 = () => interopDefault(import('../../../pages/documents/index.vue' /* webpackChunkName: "pages/documents/index" */))
const _2e2c7bb6 = () => interopDefault(import('../../../pages/identify/index.vue' /* webpackChunkName: "pages/identify/index" */))
const _0f54ef75 = () => interopDefault(import('../../../pages/information-services.vue' /* webpackChunkName: "pages/information-services" */))
const _cdafdd3c = () => interopDefault(import('../../../pages/invite/index.vue' /* webpackChunkName: "pages/invite/index" */))
const _5e96a5f4 = () => interopDefault(import('../../../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _fa14c7c0 = () => interopDefault(import('../../../pages/logout.vue' /* webpackChunkName: "pages/logout" */))
const _114325f4 = () => interopDefault(import('../../../pages/payments/index.vue' /* webpackChunkName: "pages/payments/index" */))
const _76d89563 = () => interopDefault(import('../../../pages/pdf-viewer.vue' /* webpackChunkName: "pages/pdf-viewer" */))
const _dbe4f65e = () => interopDefault(import('../../../pages/playground.vue' /* webpackChunkName: "pages/playground" */))
const _0359aa90 = () => interopDefault(import('../../../pages/s/index.vue' /* webpackChunkName: "pages/s/index" */))
const _8f584308 = () => interopDefault(import('../../../pages/settings/index.vue' /* webpackChunkName: "pages/settings/index" */))
const _d6e312d4 = () => interopDefault(import('../../../pages/sign/index.vue' /* webpackChunkName: "pages/sign/index" */))
const _fcb1669e = () => interopDefault(import('../../../pages/signup/index.vue' /* webpackChunkName: "pages/signup/index" */))
const _880276b2 = () => interopDefault(import('../../../pages/subscribe/index.vue' /* webpackChunkName: "pages/subscribe/index" */))
const _91536854 = () => interopDefault(import('../../../pages/templates/index.vue' /* webpackChunkName: "pages/templates/index" */))
const _631cff8f = () => interopDefault(import('../../../pages/verify.vue' /* webpackChunkName: "pages/verify" */))
const _b41c2970 = () => interopDefault(import('../../../pages/archive/meta.vue' /* webpackChunkName: "pages/archive/meta" */))
const _72be4e14 = () => interopDefault(import('../../../pages/builder/edit.vue' /* webpackChunkName: "pages/builder/edit" */))
const _171466c3 = () => interopDefault(import('../../../pages/builder/edit-template.vue' /* webpackChunkName: "pages/builder/edit-template" */))
const _ef2b28f8 = () => interopDefault(import('../../../pages/builder/template.vue' /* webpackChunkName: "pages/builder/template" */))
const _3244b1fa = () => interopDefault(import('../../../pages/chat/invite.vue' /* webpackChunkName: "pages/chat/invite" */))
const _32c2ff6e = () => interopDefault(import('../../../pages/documents/finalized.vue' /* webpackChunkName: "pages/documents/finalized" */))
const _4ae6b2dc = () => interopDefault(import('../../../pages/documents/meta.vue' /* webpackChunkName: "pages/documents/meta" */))
const _589603be = () => interopDefault(import('../../../pages/login/2fa.vue' /* webpackChunkName: "pages/login/2fa" */))
const _32a02073 = () => interopDefault(import('../../../pages/login/choose-account.vue' /* webpackChunkName: "pages/login/choose-account" */))
const _b9282d08 = () => interopDefault(import('../../../pages/login/forgot-password/index.vue' /* webpackChunkName: "pages/login/forgot-password/index" */))
const _6276c797 = () => interopDefault(import('../../../pages/login/password.vue' /* webpackChunkName: "pages/login/password" */))
const _528745a0 = () => interopDefault(import('../../../pages/login/passwordless.vue' /* webpackChunkName: "pages/login/passwordless" */))
const _0374b23e = () => interopDefault(import('../../../pages/login/procountor.vue' /* webpackChunkName: "pages/login/procountor" */))
const _03d422be = () => interopDefault(import('../../../pages/payments/failure.vue' /* webpackChunkName: "pages/payments/failure" */))
const _3cbf4cb7 = () => interopDefault(import('../../../pages/payments/success.vue' /* webpackChunkName: "pages/payments/success" */))
const _15575dd7 = () => interopDefault(import('../../../pages/settings/account.vue' /* webpackChunkName: "pages/settings/account" */))
const _60e4b379 = () => interopDefault(import('../../../pages/settings/confirm-email.vue' /* webpackChunkName: "pages/settings/confirm-email" */))
const _3810ae52 = () => interopDefault(import('../../../pages/settings/identify.vue' /* webpackChunkName: "pages/settings/identify" */))
const _4b1066c4 = () => interopDefault(import('../../../pages/settings/language.vue' /* webpackChunkName: "pages/settings/language" */))
const _5dc2c210 = () => interopDefault(import('../../../pages/settings/order.vue' /* webpackChunkName: "pages/settings/order" */))
const _3a9355f3 = () => interopDefault(import('../../../pages/settings/payments.vue' /* webpackChunkName: "pages/settings/payments" */))
const _2763815a = () => interopDefault(import('../../../pages/settings/profile.vue' /* webpackChunkName: "pages/settings/profile" */))
const _04ef5232 = () => interopDefault(import('../../../pages/settings/roles.vue' /* webpackChunkName: "pages/settings/roles" */))
const _04848e9c = () => interopDefault(import('../../../pages/settings/users.vue' /* webpackChunkName: "pages/settings/users" */))
const _d14fb684 = () => interopDefault(import('../../../pages/sign/invitations.vue' /* webpackChunkName: "pages/sign/invitations" */))
const _c1e83b02 = () => interopDefault(import('../../../pages/sign/item.vue' /* webpackChunkName: "pages/sign/item" */))
const _093b179b = () => interopDefault(import('../../../pages/signup/create-user.vue' /* webpackChunkName: "pages/signup/create-user" */))
const _5a412e16 = () => interopDefault(import('../../../pages/signup/create-workspace.vue' /* webpackChunkName: "pages/signup/create-workspace" */))
const _c29de2dc = () => interopDefault(import('../../../pages/signup/finago/index.vue' /* webpackChunkName: "pages/signup/finago/index" */))
const _4bc7752a = () => interopDefault(import('../../../pages/signup/verify.vue' /* webpackChunkName: "pages/signup/verify" */))
const _55ed0825 = () => interopDefault(import('../../../pages/templates/all.vue' /* webpackChunkName: "pages/templates/all" */))
const _2c020faa = () => interopDefault(import('../../../pages/templates/category.vue' /* webpackChunkName: "pages/templates/category" */))
const _278bbc4a = () => interopDefault(import('../../../pages/templates/collection.vue' /* webpackChunkName: "pages/templates/collection" */))
const _febf06d4 = () => interopDefault(import('../../../pages/templates/favourites.vue' /* webpackChunkName: "pages/templates/favourites" */))
const _36a00ae6 = () => interopDefault(import('../../../pages/templates/own/index.vue' /* webpackChunkName: "pages/templates/own/index" */))
const _1e685787 = () => interopDefault(import('../../../pages/templates/recent.vue' /* webpackChunkName: "pages/templates/recent" */))
const _419bef58 = () => interopDefault(import('../../../pages/templates/search.vue' /* webpackChunkName: "pages/templates/search" */))
const _36684e4e = () => interopDefault(import('../../../pages/login/forgot-password/finish.vue' /* webpackChunkName: "pages/login/forgot-password/finish" */))
const _dfce63d8 = () => interopDefault(import('../../../pages/settings/integrations/docusign.vue' /* webpackChunkName: "pages/settings/integrations/docusign" */))
const _98173ca8 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _5ad51131 = () => interopDefault(import('../../../pages/templates/own/_ownTemplateId.vue' /* webpackChunkName: "pages/templates/own/_ownTemplateId" */))
const _72a785d8 = () => interopDefault(import('../../../pages/templates/_templateId.vue' /* webpackChunkName: "pages/templates/_templateId" */))
const _7b104795 = () => interopDefault(import('../../../direct-to-v2.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/archive",
    component: _2a861a9f,
    name: "archive"
  }, {
    path: "/blocked",
    component: _6c6d9574,
    name: "blocked"
  }, {
    path: "/builder",
    component: _26c32e38,
    name: "builder"
  }, {
    path: "/chat",
    component: _513db31e,
    name: "chat"
  }, {
    path: "/contacts",
    component: _7f3fda2e,
    children: [{
      path: "",
      component: _61e306ac,
      name: "contacts"
    }, {
      path: "companies",
      component: _1c916cf8,
      name: "contacts-companies"
    }, {
      path: "people",
      component: _42a3a068,
      name: "contacts-people"
    }, {
      path: "companies/add",
      component: _764a88c7,
      name: "contacts-companies-add"
    }, {
      path: "people/add",
      component: _959a4f92,
      name: "contacts-people-add"
    }, {
      path: "companies/:companyId",
      component: _43d6c143,
      name: "contacts-companies-companyId"
    }, {
      path: "people/:personId",
      component: _510966c5,
      name: "contacts-people-personId"
    }]
  }, {
    path: "/documents",
    component: _ed7a6ed6,
    name: "documents"
  }, {
    path: "/identify",
    component: _2e2c7bb6,
    name: "identify"
  }, {
    path: "/information-services",
    component: _0f54ef75,
    name: "information-services"
  }, {
    path: "/invite",
    component: _cdafdd3c,
    name: "invite"
  }, {
    path: "/login",
    component: _5e96a5f4,
    name: "login"
  }, {
    path: "/logout",
    component: _fa14c7c0,
    name: "logout"
  }, {
    path: "/payments",
    component: _114325f4,
    name: "payments"
  }, {
    path: "/pdf-viewer",
    component: _76d89563,
    name: "pdf-viewer"
  }, {
    path: "/playground",
    component: _dbe4f65e,
    name: "playground"
  }, {
    path: "/s",
    component: _0359aa90,
    name: "s"
  }, {
    path: "/settings",
    component: _8f584308,
    name: "settings"
  }, {
    path: "/sign",
    component: _d6e312d4,
    name: "sign"
  }, {
    path: "/signup",
    component: _fcb1669e,
    name: "signup"
  }, {
    path: "/subscribe",
    component: _880276b2,
    name: "subscribe"
  }, {
    path: "/templates",
    component: _91536854,
    name: "templates"
  }, {
    path: "/verify",
    component: _631cff8f,
    name: "verify"
  }, {
    path: "/archive/meta",
    component: _b41c2970,
    name: "archive-meta"
  }, {
    path: "/builder/edit",
    component: _72be4e14,
    name: "builder-edit"
  }, {
    path: "/builder/edit-template",
    component: _171466c3,
    name: "builder-edit-template"
  }, {
    path: "/builder/template",
    component: _ef2b28f8,
    name: "builder-template"
  }, {
    path: "/chat/invite",
    component: _3244b1fa,
    name: "chat-invite"
  }, {
    path: "/documents/finalized",
    component: _32c2ff6e,
    name: "documents-finalized"
  }, {
    path: "/documents/meta",
    component: _4ae6b2dc,
    name: "documents-meta"
  }, {
    path: "/login/2fa",
    component: _589603be,
    name: "login-2fa"
  }, {
    path: "/login/choose-account",
    component: _32a02073,
    name: "login-choose-account"
  }, {
    path: "/login/forgot-password",
    component: _b9282d08,
    name: "login-forgot-password"
  }, {
    path: "/login/password",
    component: _6276c797,
    name: "login-password"
  }, {
    path: "/login/passwordless",
    component: _528745a0,
    name: "login-passwordless"
  }, {
    path: "/login/procountor",
    component: _0374b23e,
    name: "login-procountor"
  }, {
    path: "/payments/failure",
    component: _03d422be,
    name: "payments-failure"
  }, {
    path: "/payments/success",
    component: _3cbf4cb7,
    name: "payments-success"
  }, {
    path: "/settings/account",
    component: _15575dd7,
    name: "settings-account"
  }, {
    path: "/settings/confirm-email",
    component: _60e4b379,
    name: "settings-confirm-email"
  }, {
    path: "/settings/identify",
    component: _3810ae52,
    name: "settings-identify"
  }, {
    path: "/settings/language",
    component: _4b1066c4,
    name: "settings-language"
  }, {
    path: "/settings/order",
    component: _5dc2c210,
    name: "settings-order"
  }, {
    path: "/settings/payments",
    component: _3a9355f3,
    name: "settings-payments"
  }, {
    path: "/settings/profile",
    component: _2763815a,
    name: "settings-profile"
  }, {
    path: "/settings/roles",
    component: _04ef5232,
    name: "settings-roles"
  }, {
    path: "/settings/users",
    component: _04848e9c,
    name: "settings-users"
  }, {
    path: "/sign/invitations",
    component: _d14fb684,
    name: "sign-invitations"
  }, {
    path: "/sign/item",
    component: _c1e83b02,
    name: "sign-item"
  }, {
    path: "/signup/create-user",
    component: _093b179b,
    name: "signup-create-user"
  }, {
    path: "/signup/create-workspace",
    component: _5a412e16,
    name: "signup-create-workspace"
  }, {
    path: "/signup/finago",
    component: _c29de2dc,
    name: "signup-finago"
  }, {
    path: "/signup/verify",
    component: _4bc7752a,
    name: "signup-verify"
  }, {
    path: "/templates/all",
    component: _55ed0825,
    name: "templates-all"
  }, {
    path: "/templates/category",
    component: _2c020faa,
    name: "templates-category"
  }, {
    path: "/templates/collection",
    component: _278bbc4a,
    name: "templates-collection"
  }, {
    path: "/templates/favourites",
    component: _febf06d4,
    name: "templates-favourites"
  }, {
    path: "/templates/own",
    component: _36a00ae6,
    name: "templates-own"
  }, {
    path: "/templates/recent",
    component: _1e685787,
    name: "templates-recent"
  }, {
    path: "/templates/search",
    component: _419bef58,
    name: "templates-search"
  }, {
    path: "/login/forgot-password/finish",
    component: _36684e4e,
    name: "login-forgot-password-finish"
  }, {
    path: "/settings/integrations/docusign",
    component: _dfce63d8,
    name: "settings-integrations-docusign"
  }, {
    path: "/",
    component: _98173ca8,
    name: "index"
  }, {
    path: "/templates/own/:ownTemplateId",
    component: _5ad51131,
    name: "templates-own-ownTemplateId"
  }, {
    path: "/templates/:templateId",
    component: _72a785d8,
    name: "templates-templateId"
  }, {
    path: "/welcome",
    component: _7b104795,
    children: [{
      path: "*"
    }]
  }, {
    path: "/2",
    component: _7b104795,
    children: [{
      path: "*"
    }]
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
